export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"))
  return match ? decodeURIComponent(match[2]) : null
}
export const getAuthToken = (): string | null => {
  const nameEQ = `authToken=`
  const ca = document.cookie.split(";")
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === " ") c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export const handleLogout = () => {
  // Clear the auth token cookie
  document.cookie = "authToken=; path=/; max-age=0"

  // Redirect to the login page
  window.location.href = "/login"
}

export const skipNull = (value: any): any => {
  if (value === null || value === undefined) {
    return ""
  }
  return value
}
export const skipNullWithDash = (value: any): any => {
  if (value === null || value === undefined) {
    return "-"
  }
  return value
}
